/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiDetachCasePersonsRequest
 */
export interface InternalApiDetachCasePersonsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiDetachCasePersonsRequest
     */
    externalIds: Array<string>;
}

/**
 * Check if a given object implements the InternalApiDetachCasePersonsRequest interface.
 */
export function instanceOfInternalApiDetachCasePersonsRequest(value: object): value is InternalApiDetachCasePersonsRequest {
    if (!('externalIds' in value) || value['externalIds'] === undefined) return false;
    return true;
}

export function InternalApiDetachCasePersonsRequestFromJSON(json: any): InternalApiDetachCasePersonsRequest {
    return InternalApiDetachCasePersonsRequestFromJSONTyped(json, false);
}

export function InternalApiDetachCasePersonsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDetachCasePersonsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalIds': json['externalIds'],
    };
}

export function InternalApiDetachCasePersonsRequestToJSON(json: any): InternalApiDetachCasePersonsRequest {
    return InternalApiDetachCasePersonsRequestToJSONTyped(json, false);
}

export function InternalApiDetachCasePersonsRequestToJSONTyped(value?: InternalApiDetachCasePersonsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalIds': value['externalIds'],
    };
}

